<template>
    <div>
        <Waterfall :list="dataList" :gutter="8" :width="240"
                   :breakpoints="waterfallOptions.breakpoints"
                   animationEffect="fadeInUp" ref="videoWaterfall"
        >
            <template slot="item" slot-scope="props">

                <!--                    <div class="card">-->
                <!--                        <img :src="props.data.src" alt="" @load="$refs.waterfall.refresh()">-->
                <!--                        ...-->
                <!--                    </div>-->
                <div class="dataItem paddingB20">
                    <div class="imageArea hiddenOverflow bgF5F5F5 relative" style="border-radius: 4px 4px 0 0; min-height: 40px;" @click="viewVideo(props.data)">
                        <img class="block" :src="props.data.coverImg" width="100%" height="auto"
                             style="min-height: 60px;" data-load="$refs.videoWaterfall.refresh()"
                             v-if="props.data.coverImg"/>
                        <div class="icon playIcon2 size48" style="
                                        z-index: 1; position: absolute; right: 4px; top: 4px;">
                        </div>
                    </div>
                    <div class="marginT12 paddingH8 color101010 font14r hiddenOverflow"
                         style="line-height: 24px; max-height: 48px;" @click="viewVideo(props.data)">
                        {{ plainTextToHtml(props.data.content) }}
                    </div>
                    <div class="clearfix marginT8" style="line-height: 24px;margin:0 0 15px 0">
                        <img class="size24 circle floatL marginR8" :src="props.data.userInfo.headerImg" @click="viewUser(props.data)"/>
                        <span class="floatL font12r" @click="viewUser(props.data)">{{ props.data.userInfo.userName }}</span>
                        <span class="floatR font12r">
                            {{ props.data.praiseCount }}
<!--                        <i class="heartIcon size24 alignM floatR" @click="praise(props.data)"></i>-->
                            <i class="icon praiseIcon size20 alignM floatR" :class="{active : props.data.isPraise}" @click="praise(props.data)"></i>
                        </span>
                    </div>
                </div>
            </template>
        </Waterfall>

        <div class="alignCenter paddingV8" v-show="status === 'loading'">
            <i class="icon spinner-loader"></i>
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'ready' &&  dataList.length < 1">
            暂无任何记录
        </div>

        <div class="paddingV16 alignCenter font14r colorCCC"
             v-show="status=='ready' && pagination.current == pagination.totalPage"
             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
            没有更多记录了
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'error'">
            加载数据失败
        </div>

        <tcPlayerLayer ref="tcPlayerLayer" :image="activeVideo.coverImage" :fileID="activeVideo.fileID"/>

    </div>

</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";
import Waterfall from "vue-waterfall-plugin";
import tcPlayerLayer from "@comp/mutilMedia/tcPlayerLayer";

// config
import appConfig from '@/appConfig';

import praiseApi    from '@/api/praise';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import albumApi from "@pages/information/module/albumApi";
import bizTypeEnum from "@data/bizTypeEnum";

const config = {
    apiConfig : {
        list : {
            url : 'portal/moment/list',
            params : {
                type : 2
            },
            dataPath : 'data.records',
            totalPagePath : 'data.pages'
        }
    },
};

export default {
    extends : generalCmpPart,
    components : {
        tcPlayerLayer, Waterfall
    },
    props : {
        userId : String
    },
    data () {
        return {
            apiConfig : config.apiConfig,

            // pageSize : 8,
            enableDataList : true,

            imageGroup : 'imageGroup',

            waterfallOptions : {
                breakpoints : {
                    1200: { //当屏幕宽度小于等于1200
                        rowPerView: 4,
                    },
                    800: { //当屏幕宽度小于等于800
                        rowPerView: 3,
                    },
                    500: { //当屏幕宽度小于等于500
                        rowPerView: 2,
                    }
                }
            },

            activeVideo : {
                fileID : '',
                coverImage : ''
            }
        }
    },
    methods : {
        viewVideo(dataItem) {
            this.activeVideo.fileID = dataItem.fileId;
            // this.activeVideo.coverImage = dataItem.coverImage;
            this.$refs.tcPlayerLayer.show();
            let playerControl = this.$refs.tcPlayerLayer.getPlayerControl();
            playerControl.play();
        },
        viewUser(dataItem) {
            appHelper.goToPage('informationUser', {
                id : dataItem.userInfo.userId
            });
        },
        plainTextToHtml(text) {
            return dataMixedUtils.html.nlToBr(text);
        },
        praise(dataItem) {

            const me = this;

            if (dataItem.isPraise)
            {
                praiseApi.cancelPraise({
                    bizType : bizTypeEnum.SHIXUN_MOMENT.code,
                    id : dataItem.id
                }, () => {
                    appHelper.showHint('取消点赞成功');
                    dataItem.isPraise = !dataItem.isPraise;
                    dataItem.praiseCount--;
                    me.reloadDataList();
                });
            }
            else
            {
                praiseApi.praise({
                    bizType : bizTypeEnum.SHIXUN_MOMENT.code,
                    id : dataItem.id
                }, () => {
                    appHelper.showHint('点赞成功');
                    dataItem.isPraise = !dataItem.isPraise;
                    dataItem.praiseCount++;
                    me.reloadDataList();
                });
            }
        },
    },
    mounted() {

        if (this.userId)
        {
            this.apiConfig.list.params = {
                userId : this.userId
            }
        }
        this.loadDataList();

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {

                let item = {
                    id : index,
                    content : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    type : dataMixedUtils.number.getRandomInteger(2),
                    coverImg : appHelper.getRandomCoverImage(),
                    userInfo : {
                        userId : 1,
                        headerImg : appHelper.getRandomCoverImage(),
                        userName : dataMixedUtils.string.getRandomNickName(),
                        signature : '杭州创业小公司产品经理'
                    },
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    imgList : [],
                    video : null,
                    commentCount : dataMixedUtils.number.getRandomInteger(20),
                    praiseCount : dataMixedUtils.number.getRandomInteger(200),
                };
                if (dataMixedUtils.number.getRandomInteger(2) == 1)
                {
                    item.coverImg = appHelper.getRandomCoverImage();
                }
                else
                {
                    item.imgList = dataMixedUtils.array.buildDataList(dataMixedUtils.number.getRandomInteger(6), (index) => {
                        return appHelper.getRandomCoverImage();
                    });
                }
                return item;
            });
        }
    },
    watch : {
        userId() {
            this.apiConfig.list.params = {
                userId : this.userId
            };
            this.reloadDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
.heartIcon {
    display: inline-block;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,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');
    &.active {
        display: inline-block;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFPklEQVR4Xu2aXWgcVRTH/2e2jbUGFXxo/YjWmVR8EV+qTxZLEloaLdQKMbtJCFbUqgWRilRUCBYUqVrwo0qLNg1pJvqgKAhaRWyFihYpFEEtu9lEkzW0tdhYN8bszJGdnWR3NpvOvTOzH2VnXjbsnPM/5/zm3HtmdkKo84PqvH6EAMIOqHMC4RKo8wYIN8FwCYRLoM4JhEugzhsgnAKBLQE+sOpqLItsAJMK8LUAlgH0B5gnEMEx6kz8JNptrGtNAK8FKzeBeCUYy0E4DVAKpnGcupI/iGq52fkGwEOr7gZFdgLUCmDpogEZKZB5EJH0HuqYPFNsZwG8bMljAD8IotUuiU+A+RAwvZtiqbNuRV7svGcArDddB27YD6J2uQQ4DcZbOJV4jvqQ4Q/RAEPtA5QnAFwpp4UpgHchmniNAJb0tcw9AWBdXQPQpwBlW93r8SUMcwcUeh9Ea7yK5Pz4E6TP99BDZ/+W1ZEGwIPqHYjQNwAtdwbj3DWgrKT1h/2Z/SAJ1LYvc4GPrXVxnRNoTN9Fm1JpGQhSAPigeiMa6HuAVjqCWMm6SRUCkkmxlO1ctxfH5I8pmtgio+6WtbNOXf0CUNbnv5y70jIhCxpE0q2k+YIUjEcomtwvKi0MgA+p7VCUz+aFPda+IDFLx4fYgu7jSUSmVlPHmQsiEMQB6NpX9qgT0RWw8VF0aYr5b01+lLoS+wSSEJsC/NH112Dm8kkAS0RExW2CgpDdXxwb7WGKxjeI5CHUAaw39wAYyLe/yKYnEj5AGyfLDBrTV4lMBEEA2vMA7appAPOj184yY9xKPclf3RCLARhufhuMx3P3HDV49UvlxZl1FBs9EgwAXesHqDcnFtS6dUtN8vyCC2PeS9GR/NRaRE6sA4a0V0D0zCW1BAzzTuoeOe6GURTADhC9ekkBaJhuovsnxoMBoN+8FogcrW0AjlJTiMZvEHlCFOuAPii4RUuBaEVtboRF+xKbeyk2kn28dj2EAFhbn140Cl2lK2lQCIANUOY26hz7WSQDcQADK67A0sYEYHdBTQyEEhOJcYBi8a0ixWdthAFY9Q5pvSDqFxWvgt05GNO3U7f75jeXmxQAG4JzJFahytIh+V9EqIU64t/JpCQNwN4P9gH0sCNQde8Q/wPMLSI3PsVwPAGwIbwD0DYZ2mWynQHzZoolPvei7xmADeFNgLZ7CRyMD0/DMDdTd/KwVz1fAHIQ1NcB5SmvCXj3s35e30SxxNfeNSSnwGKBWNd2A/S0n0SkfBn/AJl7RJ723HR9d8BcAB5SXwYpO90CBnD+AmC0UzT5bQBacvcBbgFZ114E6AU3Ox/np4DZjRQdO+ZDw+EaWAfkO6H5WRBeCirBvA6fh2muD/LFaFY7cADWxjikOR+f/dJg/guMNupK/OhXqti/LAAsCMPqk2DaI/DKyK2mc8BsG0XHTrgZejlfNgA5CNp2MN7wDIHxJ2C0UCx50ktxIj5lBWDfJ2wDaK80BObTUNAq848VIgVXbAkUBmJdyz43vAuQIpYkT4IyLaLP9GKapa3K3gHz00FXtwLKe440Sr8XTIEzrRQb/cVPYaK+FQOQWw7NPWDuBy3SCYxxKGYrdY6cEi3Ar11FAVgQBtUYIjQAUMSZPP8Oc3Yddf024rcoGf+KA8h1gvYAQIMFL1sTQKaNoqOjMskHYVsVADaE+wD6AMyjMKmFuuOuv+EHUXBVpsBiifOwthEzMyepd3yiHMWJaFatA0SSq4RNCKASlGs5RtgBtXx1KpFb2AGVoFzLMcIOqOWrU4nc/gev3Z9Qm6CY7gAAAABJRU5ErkJggg==');
    }
}
.praiseIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFVUlEQVRoQ+2Za2hbZRjHl/QSrWiztVu3bvOLzPplMFBxMKYi2+iXffGDoqKzINWkbdrazHpDM1GndaZ3O6tClKKDMhQRZN6KDKZDmUwHw32oOG3rZVkaiyUlN39POae8TU4unck5GSxw6M55n/d9/v/n+b/Pe5lt1WX+s13m+FddIWB1BouaAZ/PZ5+dnX0IkpuTyeSv8Xj8+NDQ0C+FJF00Am1tbdvtdvtRm81WrwCOQWSwv7//8UKRKAqBjo4OJ0DPAn59BqAH+vr6fIUgUSwCAu55DaAPIm8jnxv5KxlZDbmFRCKxbnBw8J//S6IoBNrb278G6O2A+55I36qD7Ozs3AX4z+UdAq6BgYHDpUrgHAS2APYT9L5XBYm8pnnfQNs7tD1SqgQiEHAA7gMycL8Kkux8RttuCByDQGPJEaD6bCorK/tNgAGyN7XikIH3abqPtpO0bS85AgBsAdSQBqyJDARSJCTv+0qZwA8A3AbAJBP1eirN7ykSOoKE7qV5ggzcVVIZ8Hg8jSxen2ryMQTIHPgGAiKdANlpKhkCra2t9eXl5d8CaLNG4B4iPK4C7O7uro5EIiEISPneD4FDJUEA3UtZnABXgwb+S8DvSgWH3QN8G5PvyGsH68AJywkgm5sB/hHPJg3M6crKyp09PT1zBgQm+HYnz79TU1PV4+PjcUsIaLvM26Qc8kjVsWuRP0lk9xhtEZDYTUjsrAZYyJ3KE3ycMcdmZmbeMyJsuJUgqluYjBsVB3b0+hU13sH3ANGWBcipAkBCR8LhcFMgEIgYAUM+suq+lSdoI7NT8/PzO0dHR+fVxjQCVAk/ADtTwEVjsdgGwEdZpMIpbWd496L5Y9nAsQ/aCMlXsdGlli+XNRhu1YwPEsinsxIgUn9jUJsy+qTT6WwIBoNVOgHA/Ayh53p7e6XSJPNFcyl2KOIxfI3gMzg9PV2nSiktAxAI4mQNxoeJqkt1iISu0wkw4Da/33/6UgCttI9Woqe0fvVkYUYfIyMBDEYwdKvOpI4vLCzMyjczCSC/PbL50/w2ELhzOQnQ4Q0yIBVm6ScnLV5CZhPArw+fckCKIeWrqYKxnAQwGCYDrSoBl8u12uFwXLSAgERfsnCCoO7IOompQhe1Y98Qxm2qMamUuSFzxDQJaWuOyPZankMEdX9eBDAaxNijGnd1ddVytpUqZRoBgraVoP0oPlnQ7mb78WFeBOg0QAbaVWOq0Fqq0F8mE2gGy5viMxqN1g4PDy8qIOMc0CWEQT8Z6FCNvV7vOha0P80kwAQO4G8fzyR4blDxyL+NVuLFOUAb9n3LVmTI1dH2h5kE8KlfEIyhiAfzJmB0nnW73evZaS4uImasAy0tLTUVFRUXNNBuAjqSkwApkzovN2uvw9irdjCbABN4Lzg+zhYwo5V4kQBPWskyW0L4O4hknwTLHAuYk5KaWEkGXiMDT6gdLCCg3/B9gXx2p4I3nMS6hGjsoVO3VQSIdnkoFJojA1choxcIpn7XuoxHRgnJ3p1Okr6ln5kZQP+3gOE7cc7fxkznDSMCsmxX0+kVOj1lFQGC5SH6/fhPUPmcRmfsTBJaJMCTdvoxMwP40i/AzhBI/USWNg2yZeBlOj5jVQaYi+fxLXdMo8zFR40mcK4MvETHZ60goN8fyfUkC+YdHFuP501A2Qupfd6FzMOqhDINWODvPvweyDamkYT0yye13wXWkTrK2lp9L1RgoMuGI/By/fgi4P25/KQRYMd5DXt+KWFLbQx2njRONjc3V1RVVS07EeVysNJ2fIdramp+Uo+NK8rASh1abV+U/+Qzk9QVAmZG28jXf1bW3k/80G2uAAAAAElFTkSuQmCC');

    &.active {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAELklEQVRoQ+2ZTYwUVRCAq940rrqykNnp150Y4xHUaDiIcgA0IXogGw8aCULEgMaVnV4S9QghEPSkyRp2ehVEovwsGk0IIcQDCfHnBJJ4kCh4NP7M655hWVCBne0ui5/ByWz3dM9P78wk26fdvHr16ntVr6reG4Qu/7DL7Yc5gHZ7cNY84IzpK4BSmxj4PoH+sf6McwTXgNfsBswKgJsz1hLAYUAUFQb/iP70gD5c+LMZiMQBaAcIVzcuAeD8akOJ6CfZq57AjXCtUYjEAdzRzOMktB/CDGTP7DKy+e0dC6By8mWOnAOhBhJd0ucpiYNQagQicQ+onLkTEWrvMHor5ZD7fUcCODnzBFeb1TWNI7Cklbc7DmByX1/6+rV7FGcfrTYAfSAt9WbHATi2sZWzzzuRhpFvS8uxIuUCBBI7A1c+NORVH35lgAVRhnEm+ogz0eYouaDxxABixf5tixhgJwPs6BgA15ZvE4j34xqERIO6pfbGla+Ua7kH1Kh8AQV+yaETWzdLPq0P5b9tO4AzZr4IPo1HZp0qS1Pe1AP9Wy7+3nIAIkDX1lcgpQRp3qQu3HNhFdO1jZduNmx17Pz/BtMXvNT5MABBdL4H/j3ZZ10pVsuEupl2Q48rjK/YnoGKhSaR4A2O188rFU2MLFw4ddfdf7CyexvZxVhziKYJaI1hOUdjnQHHNm9UxqGZysnTBCxJb1bnymPcLg8Q4vFYhjQjRHQZ0L9fZt2/y2pCPaBs85/QHSXaz5Xz1QqAtQxwpBnb4s4VPq3KDKtTNQFuFSFUYUq5jz9tWGrZHYCb8Y/jcY1oSo68p6TlflcTwLF1EyD1V+hCBGe5+Vp6B2DUWEcC+QAn/2na9QfTgxO/dSUAZ7kCV2w98hDX7QFbrufKeyj5/afjMqueazmAsuUGBPHZLABsY4B3Ww7AjdsrfGn5NGkAIv9ZrgMnuxaAW44F3HJc7laACzKbX1zt5cBCVu8hno0Q4r7soGHlN3QtAAK9rmfVx8kAjJkbgWB/kodY+KWHMsPFGR1ri0LI2MRd6ycJAkxw/KeD9HcFAPdeR7n3ej45ANvgzhT3JeUBjv+3OP5HuhfAn17Kz/BnEwPgC81rfB+YkSFa4RFOn0WOf50v/tzLzfwCz0CM+8AZjskny+qS7IWiHr3Cb2Q5s8DU/UHUfKjGGWB9eYwL33K+PzT0uhzlJQGlhzPZ4i9hcqEATs7YxqlxV+BE9Fbzc/jX5bFbv8KYP/P/i6IMqmecN+oUb9SqWnPCXyX2wDy3JEcYgi/2tx+puB3kv7cEPYVfHDUeLSF+w5KB+boew2/IcuxPpYBWZix1uiGA8qTi7nQfCO0Rn0RPSqNC5WtEteL8e0av1kvPeCSWsAWPIWJjMEQKhbddHypciAKP/fwXpahd43MA7dr58rpzHmi3B/4DtK3hQD4hTzcAAAAASUVORK5CYII=');
    }
}
</style>
